import { ToggleOff } from 'components/icons/toggleoff'
import { ToggleOn } from 'components/icons/toggleon'
import { RasaContext } from 'context'
import * as GenericRedux from 'generic/genericRedux'
import { isTruthy } from 'generic/utility'
import { isNil } from 'lodash'
import * as React from 'react'
import { Input } from 'reactstrap'
import { EmailAttributes } from 'shared_server_client/constants'
import { EventConfig, TemplateModule } from 'shared_server_client/types/email_layout'
import { EditSectionProps } from '../components'
import {
  EVENT_DEFAULT_HEADER_TEXT,
  MenuSections,
} from '../constants'
import '../styles.scss'
import { ModuleConfigColorEditor } from './colors'
import { ModuleAction } from './templateModule'

interface EECProps extends EditSectionProps {
  context?: any,
  staticTextType: string,
}

interface EventEditorExtraProps extends TemplateModule {
  selectSection?: any,
  onModulePropsChange?: any,
}

type EventEditorProps = GenericRedux.AllComponentPropsWithModal<any> & EECProps & EventEditorExtraProps
export class EventEditor extends React.Component<EventEditorProps, any> {
  public static contextType = RasaContext
  constructor(props: any) {
    super(props)
    this.handleModuleChange = this.handleModuleChange.bind(this)
    this.getModuleConfig = this.getModuleConfig.bind(this)
  }

  public render() {
    const { context } = this.props
    const isShowEventHeader: boolean =
      isTruthy(this.getModuleConfig(EventConfig.EVENT_SHOW_HEADER, false))
    return context ? <div className="static-content-wrapper">
    <div className="go-back" onClick={() => this.goBack()}>&lt; &nbsp; Go back</div>
    <div className="title-description-and-toggle-container">
      <div className="title-and-toggle-container">
        <div className="title">
          {this.getModuleConfig(EventConfig.EVENT_HEADER_TEXT) || EVENT_DEFAULT_HEADER_TEXT}
        </div>
      </div>
      <div className="block">
          <div className="title">
            Maximum event count
          </div>
          <div className="description">
            What is the maximum number of events that you want to display?
          </div>
          <Input value={this.getModuleConfig('count', this.props.context.moduleConfig.count)}
                 min={1}
                 max={15}
                 type="number"
                 name={EmailAttributes.maxEvents}
                 onChange={(e) => {this.handleModuleChange('count', e.target.valueAsNumber)}}/>
      </div>
      <div className="section">
        <div className="block">
          <div className="toggle-active"
               onClick={() => this.handleModuleChange(EventConfig.EVENT_SHOW_HEADER, !isShowEventHeader)}>
            <button className="toggle-button"
                    style={{background: 'none', border: 'none', outline: 'none'}}>
              {isShowEventHeader ? <ToggleOn/> : <ToggleOff/> }
            </button>
            <span className="small-description">Show Header</span>
          </div>
        </div>
        {isShowEventHeader &&
        <div className="block">
          <Input value={this.getModuleConfig(EventConfig.EVENT_HEADER_TEXT, '')}
                 type="text"
                 placeholder={EVENT_DEFAULT_HEADER_TEXT}
                 onChange={(e) => {this.handleModuleChange(EventConfig.EVENT_HEADER_TEXT, e.target.value)}}/>
        </div>}
      </div>

      {isShowEventHeader &&
      <div className="section section-color-editor">
        <br></br>
        <ModuleConfigColorEditor type="event"
          getConfig={this.getModuleConfig}
          label=""
          onChange={(k: string, v: string) => this.handleModuleChange(k, v)} />
      </div>}
    </div>
        </div> : <div></div>
  }

  private goBack() {
    this.props.selectSection(MenuSections.layout)
  }
  private getModuleConfig = (config: string, defaultValue: any = '', defaultConfig: string = '') => {
    const templateModule = this.getCurrentTemplateModule()
    if (templateModule.moduleConfig && !isNil(templateModule.moduleConfig[config])) {
      return templateModule.moduleConfig[config]
    }

    if (defaultConfig && !isNil(this.props.data[defaultConfig])) {
      return this.props.data[defaultConfig]
    }

    return defaultValue
  }

  private getCurrentTemplateModule = () => {
    return this.props.context ? this.props.data.template_modules.filter((x) => x.type === this.props.context.type
      && x.sequence === this.props.context.sequence)[0] || this.props.context : {}
  }

  private handleModuleChange = (config: string, value: any) => {
    const templateModule: TemplateModule = this.getCurrentTemplateModule()
    templateModule.moduleConfig[config] = value
    this.props.onModulePropsChange({
      action: ModuleAction.edit,
      module: templateModule,
    })
    const moduleconfig = this.props.data.sections.find((x) => x.id === templateModule.moduleConfig.sectionId)
    if (moduleconfig && moduleconfig.category_type_name != null && config === 'count') {
      this.props.propertyChanged(`event_count_${moduleconfig.category_type_name.toLowerCase()}`, value)
      this.props.propertyChanged(`max_event_lead_count_${moduleconfig.category_type_name.toLowerCase()}`, value)
      this.props.propertyChanged(`max_event_per_source_${moduleconfig.category_type_name.toLowerCase()}`, value)
      this.props.propertyChanged(`max_event_preferred_count_${moduleconfig.category_type_name.toLowerCase()}`, value)
      this.props.propertyChanged(`minimum_event_count_${moduleconfig.category_type_name.toLowerCase()}`,
        this.getModuleConfig(`minimum_event_count_${moduleconfig.category_type_name.toLowerCase()}`, 0)
      )
    }
  }
}